/** @jsx jsx */
import { jsx } from '@compiled/react';
import { CORE_PROJECT, SOFTWARE_PROJECT } from '@atlassian/jira-common-constants/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { THIRD_PARTY_SOURCE_SLACK } from '@atlassian/jira-issue-view-common-types/src/comment-type.tsx';
import { SlackTooltip } from './slack-tooltip/SlackTooltip.tsx';
import { useCommentContext } from './CommentContextProvider.tsx';

const SlackSyncStatus = () => {
	const { parentId, projectType, isThirdPartySyncOn, thirdPartyLink, thirdPartyCommentSource } =
		useCommentContext();
	if (
		!fg('jira_issue_view_show_slack_sync_info') ||
		(projectType !== SOFTWARE_PROJECT && projectType !== CORE_PROJECT) ||
		!isThirdPartySyncOn ||
		parentId ||
		thirdPartyCommentSource !== THIRD_PARTY_SOURCE_SLACK
	) {
		return null;
	}
	return <SlackTooltip href={thirdPartyLink} />;
};

export default SlackSyncStatus;
